var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.492 1.66056C14.4925 1.80995 14.4595 1.95756 14.3955 2.09254C14.3315 2.22752 14.238 2.34644 14.122 2.44056L8.12198 7.27056C7.94304 7.41764 7.7186 7.49805 7.48698 7.49805C7.25535 7.49805 7.03091 7.41764 6.85198 7.27056L0.851975 2.27056C0.647758 2.10082 0.519334 1.85691 0.494954 1.59248C0.470574 1.32806 0.552236 1.06478 0.721975 0.860559C0.891714 0.656343 1.13562 0.527918 1.40005 0.503539C1.66448 0.479159 1.92776 0.56082 2.13197 0.730559L7.49198 5.20056L12.852 0.880559C12.9988 0.758276 13.1775 0.680599 13.3671 0.65672C13.5566 0.63284 13.749 0.663757 13.9216 0.745813C14.0941 0.827869 14.2395 0.957629 14.3406 1.11974C14.4417 1.28185 14.4942 1.46953 14.492 1.66056Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.8e75dfc5b05fd93ecf2949afe004ab40.svg";
export { ForwardRef as ReactComponent };